<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="是否超重 0-否 1-是" prop="isOverweight" >
        <a-input v-model="form.isOverweight" placeholder="请输入是否超重 0-否 1-是" />
      </a-form-model-item>
      <a-form-model-item label="基础代谢(千卡)" prop="basalMetabolism" >
        <a-input v-model="form.basalMetabolism" placeholder="请输入基础代谢(千卡)" />
      </a-form-model-item>
      <a-form-model-item label="水分" prop="waterContent" >
        <editor v-model="form.waterContent" />
      </a-form-model-item>
      <a-form-model-item label="脂肪(kg)" prop="fatRait" >
        <a-input v-model="form.fatRait" placeholder="请输入脂肪(kg)" />
      </a-form-model-item>
      <a-form-model-item label="体重(kg)" prop="weight" >
        <a-input v-model="form.weight" placeholder="请输入体重(kg)" />
      </a-form-model-item>
      <a-form-model-item label="身高(cm)" prop="height" >
        <a-input v-model="form.height" placeholder="请输入身高(cm)" />
      </a-form-model-item>
      <a-form-model-item label="蛋白质" prop="protein" >
        <a-input v-model="form.protein" placeholder="请输入蛋白质" />
      </a-form-model-item>
      <a-form-model-item label="性别,0-保密 1-男 2-女" prop="sex" >
      </a-form-model-item>
      <a-form-model-item label="BMI" prop="bmi" >
        <a-input v-model="form.bmi" placeholder="请输入BMI" />
      </a-form-model-item>
      <a-form-model-item label="体脂率" prop="bodyFatPercentage" >
        <a-input v-model="form.bodyFatPercentage" placeholder="请输入体脂率" />
      </a-form-model-item>
      <a-form-model-item label="去脂体重(kg)" prop="degreasingWeight" >
        <a-input v-model="form.degreasingWeight" placeholder="请输入去脂体重(kg)" />
      </a-form-model-item>
      <a-form-model-item label="肌肉率" prop="muscleRait" >
        <a-input v-model="form.muscleRait" placeholder="请输入肌肉率" />
      </a-form-model-item>
      <a-form-model-item label="肌肉量(kg)" prop="muscleNum" >
        <a-input v-model="form.muscleNum" placeholder="请输入肌肉量(kg)" />
      </a-form-model-item>
      <a-form-model-item label="皮下脂肪" prop="subcutaneousFat" >
        <a-input v-model="form.subcutaneousFat" placeholder="请输入皮下脂肪" />
      </a-form-model-item>
      <a-form-model-item label="体内水分" prop="internalWaterContent" >
        <editor v-model="form.internalWaterContent" />
      </a-form-model-item>
      <a-form-model-item label="骨骼肌" prop="skeletalMuscle" >
        <a-input v-model="form.skeletalMuscle" placeholder="请输入骨骼肌" />
      </a-form-model-item>
      <a-form-model-item label="骨重(kg)" prop="boneWeight" >
        <a-input v-model="form.boneWeight" placeholder="请输入骨重(kg)" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBodyCompositionRecord, addBodyCompositionRecord, updateBodyCompositionRecord } from '@/api/joe/bodyCompositionRecord'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        isOverweight: null,

        basalMetabolism: null,

        waterContent: null,

        fatRait: null,

        weight: null,

        height: null,

        protein: null,

        sex: null,

        bmi: null,

        bodyFatPercentage: null,

        degreasingWeight: null,

        muscleRait: null,

        muscleNum: null,

        subcutaneousFat: null,

        internalWaterContent: null,

        skeletalMuscle: null,

        boneWeight: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        isOverweight: null,
        basalMetabolism: null,
        waterContent: null,
        fatRait: null,
        weight: null,
        height: null,
        protein: null,
        sex: null,
        bmi: null,
        bodyFatPercentage: null,
        degreasingWeight: null,
        muscleRait: null,
        muscleNum: null,
        subcutaneousFat: null,
        internalWaterContent: null,
        skeletalMuscle: null,
        boneWeight: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBodyCompositionRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateBodyCompositionRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBodyCompositionRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
